module.exports = __webpack_public_path__ + "static/media/logo.cd5890e6.svg";